import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from 'material-ui/styles';
import Radio, { RadioGroup } from 'material-ui/Radio';
import { FormControl, FormControlLabel, FormLabel } from 'material-ui/Form';

const styles = theme => ({
  inline: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
  },
  checked: {
    color: theme.palette.primary.A700,
  },
  radio: {
    marginRight: -theme.spacing.unit,
  },
});

const RadioWidget = props => {
  const {
    classes,
    uiSchema,
    schema,
    formContext,
    options,
    value,
    required,
    disabled,
    readonly,
    autofocus,
    onChange,
  } = props;

  // Generating a unique field name to identify this set of radio buttons
  const name = Math.random().toString();
  const { enumOptions, inline } = options;
  const title =
    uiSchema && uiSchema['ui:title'] ? uiSchema['ui:title'] : schema.title;

  // checked={checked} has been moved above name={name}, As mentioned in #349;
  // this is a temporary fix for radio button rendering bug in React, facebook/react#7630.
  const _onChange = (e, val) => {
    const value = props.schema.type === 'boolean' ? val === 'true' : val;
    onChange(value);
  };

  return (
    <FormControl disabled={disabled || formContext.formStatus !== 'editable'}>
      {title && <FormLabel>{title}</FormLabel>}
      <RadioGroup
        name={name}
        value={value + ''}
        className={classnames({
          [classes.inline]: inline,
        })}
        onChange={_onChange}
      >
        {enumOptions.map((option, i) => {
          const checked = option.value === value;
          return (
            <FormControlLabel
              key={i}
              disabled={
                disabled || readonly || formContext.formStatus !== 'editable'
              }
              checked={checked}
              value={option.value + ''}
              control={
                <Radio
                  className={classes.radio}
                  classes={{ checked: classes.checked }}
                />
              }
              label={option.label}
              required={required}
              autoFocus={autofocus && i === 0}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

RadioWidget.defaultProps = {
  autofocus: false,
};

RadioWidget.propTypes = {
  classes: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object,
  formContext: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  options: PropTypes.shape({
    enumOptions: PropTypes.array,
    inline: PropTypes.bool,
  }).isRequired,
  value: PropTypes.any,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autofocus: PropTypes.bool,
  onChange: PropTypes.func,
};

export default withStyles(styles)(RadioWidget);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/RadioWidget.js